import { useEffect } from 'react'

const RedirectToAppWithRef = () => {
    useEffect(() => {
        const isAndroid = /Android/i.test(navigator.userAgent)
        if (!isAndroid) {
            window.location.pathname = '/'
            return
        }

        const params = new URLSearchParams(window.location.search)
        const referrer = params.get('referrer') || 'unknown'

        // Пробуем открыть через кастомную схему
        const deepLink = `stellarsoft://stellarhome?referrer=${encodeURIComponent(referrer)}`
        window.location.href = deepLink

        // Через 2 секунды — fallback на APK
        const fallbackTimer = setTimeout(() => {
            window.location.href = '/stellarhome.apk'
        }, 2000)

        return () => clearTimeout(fallbackTimer)
    }, [])

    return (
        <div style={{ textAlign: 'center', marginTop: '2rem', color: 'white' }}>
            <p>Trying to open the app...</p>
        </div>
    )
}

export default RedirectToAppWithRef
